<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Users"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.name"
                  label="Nombre"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="last_name"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.last_name"
                  label="Apellido"
                  prepend-inner-icon="fas fa-user"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="iva_condition"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  :error-messages="errors"
                  v-model="data.iva_condition"
                  :items="iva_conditions"
                  label="Condición ante el IVA"
                ></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                ref="email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.email"
                  label="E-mail"
                  prepend-inner-icon="fas fa-envelope"
                ></v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col>
              <ValidationProvider
                ref="password"
                rules="min:4"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.password"
                  label="Contraseña"
                  :type="show1 ? 'text' : 'password'"
                  :append-icon="show1 ? 'fas fa-eye' : 'fas fa-eye-slash'"
                  @click:append="show1 = !show1"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider
                ref="phone_number"
                rules=""
                v-slot="{ errors }"
              >
                <v-text-field
                  name="phone_number"
                  label="Teléfono"
                  prepend-inner-icon="fa fa-phone"
                  type="number"
                  v-model="data.phone_number"
                  :error-messages="errors[0]"
                  :error="errors.length > 0"
                />
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="commission_percentage"
                rules="percentage_valid"
                v-slot="{ errors }"
              >
                <v-text-field
                  name="commission_percentage"
                  label="Comisión"
                  prepend-inner-icon="fas fa-percent"
                  type="number"
                  v-model="data.commission_percentage"
                  :error-messages="errors[0]"
                  :error="errors.length > 0"
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="cuil" rules="" v-slot="{ errors }">
                <v-text-field
                  :error-messages="errors"
                  v-model="data.cuil"
                  label="Cuil"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider
                ref="code_validation_email"
                rules=""
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.code_validation_email"
                  label="Codigo de verificacion de E-mail"
                  prepend-inner-icon="fas fa-user"
                  readonly
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider
                ref="profile_picture"
                rules=""
                v-slot="{ errors }"
              >
                <Upload
                  :error-messages="errors"
                  accept="image/png, image/jpeg, image/jpg"
                  placeholder="Imagen de Perfil"
                  prepend-icon="fas fa-camera"
                  label=""
                  :multiple="false"
                  :onSelectedPicture="onSelectedPicture"
                ></Upload>
                <v-img
                  :src="profile_picture"
                  width="200"
                  style="margin: auto"
                ></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },

  data() {
    return {
      storeName: "Users",
      title: "Usuario",
      filteredAttributes: ["profile_picture"],
      show1: false,
      profile_picture: "",
      data: {
        name: "",
        last_name: "",
        iva_condition: "",
        email: "",
        password: "",
        phone_number: "",
        cuil: "",
        profile_picture: undefined,
        commission_percentage: null,
        code_validation_email: "",
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Users.status,
      iva_conditions: (state) => state.Users.iva_conditions,
    }),
  },
  watch: {},
  methods: {
    onSelectedPicture(file) {
      const self = this;
      this.data.profile_picture = file;

      let fr = new FileReader();
      fr.onload = function() {
        self.profile_picture = fr.result;
      };
      fr.onerror = function() {
        self.profile_picture = "";
      };
      fr.readAsDataURL(this.data.profile_picture);
    },
  },
};
</script>
